import React, { useState } from 'react';
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase'; // Import the auth reference
import { RiGoogleLine } from 'react-icons/ri'; // Import Google icon from React Icons
function SignIn() {

    const [error, setError] = useState(null);

    const navigate = useNavigate();
    // Listener for auth state changes

    const handleGoogleSignIn = async () => {
        const provider = new GoogleAuthProvider();
        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            console.log(user)
            navigate('/dashboard');
            // redirect to dashboard on successful sign-in
        } catch (err) {
            if(err.message.indexOf("(auth/admin-restricted-operation).") > -1){
                setError("Invalid Account Email.");
            }
        }
    }

   
    return (
        <div style={{ height: "calc(100vh - 12em)" }} className="flex flex-col justify-center items-center">
            <div className="h-full m-auto w-[20rem] p-5 shadow-xl bg-primary rounded-lg">
                <div>
                    <h2 className="text-white text-3xl md:text-5xl font-semibold pb-1">Sign In</h2>

                    <button onClick={handleGoogleSignIn} className="flex items-center justify-center w-full  text-md md:text-xl font-semibold text-red-500 outline-none bg-white rounded-sm p-2 mt-4 hover:text-white hover:bg-red-500 hover:outline-white duration-300">
                        <RiGoogleLine className="mr-2" size={24} /> Sign In with Google
                    </button>
                    {error && <p className="text-black text-md md:text-xl font-light mt-2">{error}</p>}

                </div>
            </div>
        </div>
    );
}

export default SignIn;